import React from "react";

const SpecialAssistance = () => {
  return (
    <div className="min-h-screen bg-slate-50 font-sans py-12 lg:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <div className="inline-block bg-blue-100 text-blue-700 p-4 rounded-full mb-6 text-3xl">
            ♿
          </div>
          <h1 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight mb-4">
            Accessible Travel for Everyone
          </h1>
          <p className="text-slate-500 text-lg font-medium">
            We are committed to making your journey comfortable. Let us know how
            we can assist you.
          </p>
        </div>

        <div className="bg-white rounded-[2rem] border border-slate-200 shadow-xl overflow-hidden">
          <div className="p-8 sm:p-12">
            <h2 className="text-xl font-bold text-slate-900 mb-6 border-b border-slate-100 pb-4">
              Request Assistance for an Existing Booking
            </h2>

            <form className="space-y-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                    Booking Reference (PNR)
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. X7B9Q2"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 outline-none focus:border-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                    Passenger Last Name
                  </label>
                  <input
                    type="text"
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 outline-none focus:border-blue-500"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-4">
                  Select Required Assistance
                </label>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    "Wheelchair (to ramp)",
                    "Wheelchair (to seat)",
                    "Hearing Impaired Support",
                    "Visually Impaired Support",
                    "Service Animal",
                    "Medical Equipment (CPAP)",
                  ].map((item, idx) => (
                    <label
                      key={idx}
                      className="flex items-center gap-3 p-4 border border-slate-200 rounded-xl cursor-pointer hover:bg-slate-50 transition-colors"
                    >
                      <input
                        type="checkbox"
                        className="w-5 h-5 rounded border-slate-300 text-blue-600 focus:ring-blue-500"
                      />
                      <span className="font-semibold text-slate-700 text-sm">
                        {item}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold text-slate-500 uppercase mb-2">
                  Additional Details
                </label>
                <textarea
                  placeholder="Please provide any extra context we should share with the airline..."
                  rows="3"
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 outline-none focus:border-blue-500 resize-none"
                ></textarea>
              </div>

              <div className="bg-blue-50 p-4 rounded-xl flex items-start gap-3">
                <span className="text-blue-600 text-xl">ℹ️</span>
                <p className="text-xs text-blue-800 font-medium">
                  Please submit requests at least 48 hours before departure to
                  ensure airlines can accommodate your needs.
                </p>
              </div>

              <button
                type="button"
                className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-bold py-3.5 px-10 rounded-xl transition-all active:scale-95 shadow-md shadow-blue-600/20"
              >
                Submit Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialAssistance;
